import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { getMyEvents, deleteMyEvent, resubmitMyEvent } from '../../api/pro';
import { PageHeader } from '../../components/layout/PageHeader';
import { DataTable } from '../../components/ui/DataTable';
import { StatusBadge } from '../../components/ui/StatusBadge';
import { useProEntry } from '../../contexts/ProEntryContext';
export default function ProEventList() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { activeEntryId } = useProEntry();
    const { data, isLoading } = useQuery({
        queryKey: ['my-events', activeEntryId],
        queryFn: () => getMyEvents(activeEntryId),
        enabled: activeEntryId != null,
    });
    const deleteMut = useMutation({
        mutationFn: deleteMyEvent,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['my-events'] }),
    });
    const resubmitMut = useMutation({
        mutationFn: resubmitMyEvent,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['my-events'] }),
    });
    const columns = [
        { key: 'title', header: 'Titre', render: (e) => _jsx("span", { className: "font-medium", children: e.title }) },
        { key: 'start_date', header: 'Date', render: (e) => new Date(e.start_date).toLocaleDateString('fr-FR') },
        { key: 'location', header: 'Lieu', render: (e) => e.location ?? '-' },
        { key: 'published', header: 'Statut', render: (e) => _jsx(StatusBadge, { status: e.rejected ? 'rejected' : e.published ? 'published' : 'submitted' }) },
        { key: 'actions', header: '', render: (e) => (_jsxs("div", { className: "flex gap-3 justify-end", children: [e.rejected && _jsx("button", { onClick: (ev) => { ev.stopPropagation(); resubmitMut.mutate(e.id); }, disabled: resubmitMut.isPending, className: "text-xs text-blue-600 hover:text-blue-800 disabled:opacity-50", children: "Re-soumettre" }), _jsx("button", { onClick: (ev) => { ev.stopPropagation(); if (confirm('Supprimer ?'))
                            deleteMut.mutate(e.id); }, className: "text-xs text-red-500 hover:text-red-700", children: "Supprimer" })] })) },
    ];
    return (_jsxs(_Fragment, { children: [_jsx(PageHeader, { title: "Mes \u00E9v\u00E9nements", subtitle: `${data?.total ?? 0} événement(s)`, actions: _jsx("button", { onClick: () => navigate('/pro/events/new'), className: "px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700", children: "Nouvel \u00E9v\u00E9nement" }) }), _jsx(DataTable, { columns: columns, data: data?.data ?? [], isLoading: isLoading, onRowClick: (e) => navigate(`/pro/events/${e.id}/edit`) })] }));
}
